import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  cardWrap: {
    padding: '20px 30px',
    backgroundColor: '#1e1e25',
    color: '#FFFFFF',
    cursor: 'pointer',
    marginBottom: 20,
    '&:hover': {
      transform: 'scale(1.01)'
    }
  },
  cardHead: {
    display: 'flex',
    alignItems: 'center',
    gap: 20,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
    '& .cTitle': {
      fontSize: '1.4em',
    },
    '& .cInstitution': {
      fontSize: '1.2em',
      color: '#FF6900',
      fontStyle: 'italic',
      textDecoration: 'underline',

    },
  },
  datesRange: {
    color: '#FF6900',
    fontStyle: 'italic',
    fontSize: '1em',
    margin: '5px 0',
  },
  cardDescription: {
    fontSize: '1.2em',
    fontWeight: 200,
    textOverflow: 'wrap',
  },
}));

export default useStyles;
